import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PrimeConfirmDialog from "../../../components/dialog/PrimeConfirmDialog";
import { FormInputFile } from "../../../components/FormInputFile";
import ImagePDFComponent from "../../../components/ImagePDFComponent";
import PrimePanel from "../../../components/PrimePanel";
import { deleteIdentifyItem, updateIdentifyInfo } from "../../../utility/service/carbon-service";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import { Checkbox } from "primereact/checkbox";
import { useContext } from "react";
import { AcctContext } from "../../../utility/useReduce/userNameReduce";

const CategoryList = ({
  header,
  dataReordered,
  data,
  sortableElement,
  tableOpen,
  setTableOpen,
  axios_queryPlanClassList,
  handleSuccessMessage,
  dispatch,
  classSeq,
  editItem,
  currentIndex,
  orginalData,
  classNo,
  isEditable,
  batchAction,
  dataDel,
  register,
  handleDeleteImg,
  handleFileChange,
  approveFlag,
  companySeq,
}) => {
  const [delDialog, setDelDialog] = useState(false);
  const [delObj, setDelObj] = useState({});
  const [delContent, setDelContent] = useState("");
  const { t } = useTranslation();
  const [state] = useContext(AcctContext);
  const [dataList, setDataList] = useState(data);
  const sensors = useSensors(useSensor(PointerSensor));
  const [selectValue, setSelectValue] = useState([]);

  useEffect(() => {
    const isAdmin = state?.isAdmin === "Y";
    setDataList(data);
    if (batchAction === "") {
      setSelectValue([]);
    }
    if (approveFlag && (batchAction === "delete" || batchAction === "upload") && !isAdmin) {
      setDataList(data.filter((item) => item.status === "D"));
    } else {
      setDataList(data);
    }
  }, [data, batchAction, approveFlag, state?.isAdmin]);

  const deleteItem = (rowData) => {
    setDelObj(rowData);
    setDelContent(`${t("identifyiNo")}: ${rowData.identifySeq}`);
    setDelDialog(true);
  };

  const confirmDel = () => {
    axios_deleteIdentifyItem(delObj?.identifySeq);
  };

  const axios_deleteIdentifyItem = (identifySeq) => {
    deleteIdentifyItem({ identifySeq: [identifySeq] }).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
        axios_queryPlanClassList("edit");
        setDelDialog(false);
      }
    });
  };

  const axios_updateSortItem = (itemObj, sort, isUpdate) => {
    // 單純更新資料 不須傳檔案相關參數
    const formData = new FormData();
    formData.append("identifySeq", itemObj?.identifySeq);
    formData.append("classSeq", itemObj?.classSeq);
    formData.append("typeSeq", itemObj?.typeSeq);
    formData.append("sourceSeq", itemObj?.sourceSeq);
    formData.append("isCalculate", itemObj?.isCalculate);

    if (itemObj?.processCode) {
      formData.append("processCode", itemObj?.processCode);
    }
    if (itemObj?.deviceCode) {
      formData.append("deviceCode", itemObj?.deviceCode);
    }
    if (itemObj?.quantity) {
      formData.append("quantity", itemObj?.quantity);
    }
    if (itemObj?.customerNo) {
      formData.append("customerNo", itemObj?.customerNo);
    }

    if (itemObj?.remark) {
      formData.append("remark", itemObj?.remark);
    }

    formData.append("sort", sort);
    formData.append("delData", "N");
    formData.append("materialType", itemObj?.materialType);
    formData.append("materialCode", itemObj?.materialCode);
    formData.append("isBiomass", itemObj?.isBiomass);
    formData.append("isCHP", itemObj?.isCHP);
    formData.append("sourceType", itemObj?.sourceType);

    // 類四參數 不用傳
    // if(itemObj?.hasCustom==='Y'){
    //     formData.append("hasCustom",itemObj?.hasCustom);
    //     formData.append("customRate1",itemObj?.customRate1);
    //     formData.append("customRateSource",itemObj?.customRateSource);
    //     formData.append("customRateType",itemObj?.customRateType);
    //     formData.append("customEmission",itemObj?.customEmission);
    //     formData.append("customDesc",itemObj?.customDesc);
    // }

    // for (var [a, b] of formData.entries()) {
    //     console.log(a, b);
    //  }
    //  console.log("印出formData資料-----break-----");

    // let reqBody = {
    //     identifySeq:itemObj?.identifySeq,
    //     classSeq:classSeq,
    //     typeSeq:itemObj?.typeSeq,
    //     processCode:itemObj?.processCode,
    //     deviceCode:itemObj?.deviceCode,
    //     sourceSeq:itemObj?.sourceSeq,
    //     quantity:itemObj?.quantity,
    //     isCalculate:itemObj?.isCalculate,
    //     remark:itemObj?.remark,
    //     fileExtension:itemObj?.fileExtension,
    //     fileName:itemObj?.fileName,
    //     devicePic:itemObj?.devicePic,
    //     sort:sort.toString()
    // }

    updateIdentifyInfo(formData).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
        if (isUpdate) {
          axios_queryPlanClassList();
        }
      }
    });
  };

  const rowIndexTemplate = (rowData, { rowIndex }) => <span>{rowIndex + 1}</span>;

  const approveStatusBodyTemplate = (status) => {
    const colorMap = {
      D: "var(--gray-400)",
      C: "var(--green-700)",
      P: "var(--yellow-300)",
      RTA: "var(--red-600)",
    };
    const textColorMap = {
      P: "var(--yellow-800)",
    };

    if (status) {
      return (
        <span
          className={`p-tag`}
          style={{ background: colorMap[status] || "var(--gray-300)", color: textColorMap[status] || "#fff" }}
        >
          {t(`approve.${status}`)}
        </span>
      );
    }
  };

  const actionBodyTemplate = (rowData, props) => {
    const isAdmin = state?.isAdmin === "Y" && state?.companySeq === companySeq && rowData?.status === "C";
    const isDraft = rowData?.status === "D";
    const isRTA = rowData?.status === "RTA";

    const isRTAEditable = isRTA && (rowData?.applyAdmin ?? false);
    const isRTAViewable = isRTA && !(rowData?.applyAdmin ?? false);

    const canEditOrDelete = isAdmin || !approveFlag || isDraft || isRTAEditable;
    const canView = approveFlag && !isDraft && (!isRTA || isRTAViewable) && !isAdmin;
    return (
      <div className="flex gap-1 items-center justify-center">
        {/* 查看 */}
        {canView && (
          <Button
            tooltip={t("button.detail")}
            tooltipOptions={{ position: "top" }}
            onClick={() => editItem(rowData, rowData.classSeq, "detail")}
            className="p-button-icon-only"
            rounded
            text
            severity="secondary"
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
        )}

        {/* 編輯 */}
        {canEditOrDelete && (
          <Button
            tooltip={t("button.edit")}
            tooltipOptions={{ position: "top" }}
            onClick={() => editItem(rowData, rowData.classSeq, "edit")}
            className="p-button-icon-only"
            rounded
            text
            severity="secondary"
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-edit" />
          </Button>
        )}

        {/* 複製 */}
        <Button
          tooltip={t("copy")}
          tooltipOptions={{ position: "top" }}
          disabled={!isEditable}
          onClick={() => editItem(rowData, rowData.classSeq, "copy")}
          className="p-button-icon-only"
          rounded
          text
          severity="secondary"
          style={{ width: "2rem", height: "2rem" }}
        >
          <FontAwesomeIcon icon="fa-solid fa-copy" />
        </Button>

        {/* 刪除 */}
        {canEditOrDelete && (
          <Button
            tooltip={t("button.delete")}
            tooltipOptions={{ position: "top" }}
            disabled={!isEditable}
            onClick={() => deleteItem(rowData)}
            className="p-button-icon-only"
            rounded
            text
            severity="danger"
            style={{ width: "2rem", height: "2rem" }}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash-can" />
          </Button>
        )}
      </div>
    );
  };

  const textEllipsis = (rowData, props) => {
    const uid = `${[props.field]}-${rowData?.identifySeq}`;
    return (
      <span id={uid} className="text-ellipsis">
        {rowData?.[props.field]}
        <Tooltip target={`#${uid}`} content={rowData?.[props.field]} position="bottom" mouseTrack />
      </span>
    );
  };

  const fileBodyTemplate = (rowData, props) => {
    return (
      <>
        {batchAction === "upload" && (
          <FormInputFile
            register={register}
            limitSize="5MB"
            wrapperClass="in-table-cell"
            acceptFileType=".jpg,.png,.pdf"
            id={`fileName_${rowData?.fileId}`}
            name={`fileName_${rowData?.fileName}`}
            fileChange={(e) => {
              handleFileChange?.(e, rowData);
            }}
          />
        )}

        <ImagePDFComponent
          key={`${rowData.fileId}-${rowData.filePath}-${rowData.fileName}-${rowData.fileExtension}`}
          wrapperClass="mt-2"
          imgWidth={batchAction === "upload" ? "80" : "40"}
          imgHeight={batchAction === "upload" ? "80" : "40"}
          file={{
            type: rowData?.fileExtension,
            name: `${rowData?.fileName}.${rowData?.fileExtension}`,
          }}
          zoomSrc={rowData?.filePath} //原圖
          previewUrl={rowData?.fileExtension === "pdf" ? rowData?.filePath : rowData?.filePathSml} //縮圖
          disabled={batchAction !== "upload"}
          {...(batchAction === "upload" ? { deleteImg: (e) => handleDeleteImg?.(rowData?.fileId) } : {})}
        />
      </>
    );
  };

  const SortableRow = ({ rowData, field, rowIndex, isButton, body }) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
      id: rowData.identifySeq,
    });

    const style = {
      transform: CSS.Translate.toString(transform),
      transition,
      position: "relative",
      zIndex: isDragging ? 9999 : "auto",
    };

    return (
      <tr ref={setNodeRef} style={style} {...attributes}>
        {/* 拖動手把 */}
        <td className="text-ellipsis">
          {isButton && (
            <Button
              className="p-button-icon-only"
              icon="pi pi-bars"
              rounded
              text
              style={{ cursor: "grab" }}
              ref={setActivatorNodeRef}
              {...listeners}
            />
          )}
          {!isButton && (body ?? rowIndex ?? rowData[field])}
        </td>
      </tr>
    );
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = dataList.findIndex((p) => p.identifySeq === active.id);
    const newIndex = dataList.findIndex((p) => p.identifySeq === over.id);

    const newList = arrayMove(dataList, oldIndex, newIndex);

    setDataList(newList);
    dataReordered?.(newList);
  };

  const dataTable = () => {
    return (
      <DataTable
        value={dataList}
        stripedRows
        className="white-data-table hover-highlight no-shadow last-row-no-border"
        emptyMessage={t("no_rec")}
        scrollable
        scrollHeight="35rem"
        {...(batchAction !== "sort" && { resizableColumns: true })}
        {...(dataList?.length > 20 && { virtualScrollerOptions: { itemSize: batchAction === "upload" ? 166 : 73 } })}
        {...(batchAction === "delete" && {
          selectionMode: "checkbox",
          selection: selectValue,
          onSelectionChange: (e) => {
            setSelectValue(e.value);
            dataDel?.(e.value);
          },
        })}
        {...(batchAction === "delete" &&
          selectValue.length > 0 && {
            footer: (
              <div className="text-right">
                <span>{t("selectedCount", { count: selectValue.length })}</span>
              </div>
            ),
          })}
      >
        {batchAction === "delete" && (
          <Column frozen selectionMode="multiple" style={{ width: "80px" }} bodyStyle={{ maxWidth: "80px" }} />
        )}
        {batchAction === "sort" && (
          <Column
            frozen
            style={{ width: "80px" }}
            bodyStyle={{ maxWidth: "80px" }}
            body={(rowData) => <SortableRow rowData={rowData} isButton={true} />}
          />
        )}
        {approveFlag && (
          <Column
            frozen
            field="status"
            style={{ width: "80px" }}
            bodyStyle={{ maxWidth: "80px" }}
            body={(rowData, { rowIndex }) =>
              batchAction === "sort" ? (
                <SortableRow rowData={rowData} isButton={false} body={approveStatusBodyTemplate(rowData?.status)} />
              ) : (
                approveStatusBodyTemplate(rowData?.status)
              )
            }
          />
        )}
        <Column
          frozen
          field="itemNo"
          header={t("itemNo")}
          style={{ width: "80px" }}
          bodyStyle={{ maxWidth: "80px" }}
          body={(rowData, { rowIndex }) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} rowIndex={rowIndex + 1} />
            ) : (
              rowIndexTemplate(rowData, { rowIndex })
            )
          }
        />
        <Column
          field="placeName"
          header={t("place")}
          style={{ width: "100px" }}
          bodyStyle={{ maxWidth: "100px" }}
          body={(rowData, props) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} field={"placeName"} />
            ) : (
              textEllipsis(rowData, props)
            )
          }
        />
        <Column
          field="typeName"
          header={t("emission_pattern")}
          style={{ width: "200px" }}
          bodyStyle={{ maxWidth: "200px" }}
          body={(rowData, props) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} field={"typeName"} />
            ) : (
              textEllipsis(rowData, props)
            )
          }
        />
        <Column
          field="deviceName"
          header={t("equipment")}
          style={{ width: "180px" }}
          bodyStyle={{ maxWidth: "180px" }}
          body={(rowData, props) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} field={"deviceName"} />
            ) : (
              textEllipsis(rowData, props)
            )
          }
        />
        <Column
          field="sourceName"
          header={t("emission_source")}
          style={{ width: batchAction === "sort" ? "200px" : "150px" }}
          bodyStyle={{ maxWidth: batchAction === "sort" ? "200px" : "150px" }}
          body={(rowData, props) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} field={"sourceName"} />
            ) : (
              textEllipsis(rowData, props)
            )
          }
        />
        <Column
          field="isCalculate"
          header={t("is_calculate")}
          style={{ width: "80px" }}
          bodyStyle={{ maxWidth: "80px" }}
          body={(rowData, {}) =>
            batchAction === "sort" ? (
              <SortableRow
                rowData={rowData}
                isButton={false}
                field={"isCalculate"}
                body={<Checkbox checked={rowData.isCalculate === "Y"} disabled />}
              />
            ) : (
              <Checkbox checked={rowData.isCalculate === "Y"} disabled />
            )
          }
        />
        {batchAction !== "sort" && (
          <Column
            field="fileExtension"
            header={`${t("attached_picture")}/${t("attachments")}`}
            style={{ width: batchAction === "upload" ? "200px" : "150px" }}
            bodyStyle={{ maxWidth: batchAction === "upload" ? "200px" : "150px" }}
            body={fileBodyTemplate}
          />
        )}
        <Column
          field="remark"
          header={t("remark")}
          style={{ width: batchAction === "sort" ? "200px" : "150px" }}
          bodyStyle={{ maxWidth: batchAction === "sort" ? "200px" : "150px" }}
          body={(rowData, props) =>
            batchAction === "sort" ? (
              <SortableRow rowData={rowData} isButton={false} field={"remark"} />
            ) : (
              textEllipsis(rowData, props)
            )
          }
        />
        {batchAction === "" && (
          <Column
            frozen
            alignFrozen="right"
            field="action"
            header={t("action")}
            style={{ width: "200px" }}
            bodyStyle={{ maxWidth: "200px" }}
            body={actionBodyTemplate}
          />
        )}
      </DataTable>
    );
  };

  return (
    <>
      <PrimePanel header={`${header} (${dataList?.length})`} toggleable className="dataTable-panel">
        {batchAction === "sort" ? (
          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={dataList.map((p) => p.identifySeq)} strategy={verticalListSortingStrategy}>
              {dataTable()}
            </SortableContext>
          </DndContext>
        ) : (
          dataTable()
        )}
      </PrimePanel>

      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
        }}
        onConfirm={() => {
          confirmDel();
        }}
        title={t("button.delete")}
        bodyTemplate={delContent}
      />
    </>
  );
};

export default CategoryList;
